module.exports = __webpack_public_path__ + "img/6-min.85ac12d5.jpg";